import React from 'react';
import { Select } from '@chakra-ui/react';

export default function FilterSelect({ 
  value, 
  onChange, 
  options = [], 
  placeholder = 'Select...',
  maxW = '220px',
  ...props 
}) {
  return (
    <Select
      value={value || ''}
      onChange={e => onChange(e.target.value || undefined)}
      placeholder={placeholder}
      maxW={maxW}
      bg="white"
      variant="filled"
      borderRadius="full"
      {...props}
    >
      {options.map(option => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </Select>
  );
}
